import { FieldParams } from "../../core/FieldObject";
import {
  DeepMergeObject,
  DotStringToObject,
  getCellStyle,
  GetHeaderStyle,
  PostJson,
} from "../../core/Helper";
import { FieldDataType, FormControlType } from "../../core/Helper2";
import { GetThaiDateTimeCheckToday } from "../../core/ThaiDate";

export const AppointObj = (props) => {
  const {
    docuList,
    onSelectDocument,
    patientClick,
    goodClick,
    physicianClick,
    customerClick,
    rightClick,
  } = props;

  const cancleClick = (item, setObject) => {
    if (!setObject) return;
    setObject((pv) => ({
      ...pv,
      ...DeepMergeObject(
        DotStringToObject(item.fieldName + "." + item.searchValueName, 0),
        DotStringToObject(item.fieldName + "." + item.searchDisplayName, null)
      ),
    }));
  };
  return {
    AppointId: {
      ...new FieldParams(
        "AppointId",
        "",
        true,
        FieldDataType.NUMERIC,
        FormControlType.HIDDEN
      ),
      isHiddenColumn: true,
    },
    BranchDocu: {
      ...new FieldParams(
        "BranchDocu",
        "ประเภทเอกสาร",
        true,
        FieldDataType.NUMERIC,
        FormControlType.SELECT
      ),
      selectData: docuList,
      selectHasFirstOption: false,
      selectValueName: "DocuBrchId",
      selectDisplayName: "DocuType.DocuTypeName", // [docuList].DocuType.DocuTypeName
      tableColumnFieldName: "DocuBranch.BranchDocu.DocuType.DocuTypeName",
      onChange: onSelectDocument,
      defaultHeaderStyle: GetHeaderStyle("100px"),
      defaultCellStyle: getCellStyle("center"),
      //disabled: head?.[docuFieldIdName] ? true : false,
    },
    DocuNo: {
      ...new FieldParams("DocuNo", "เลขที่ใบนัด"),
      defaultHeaderStyle: GetHeaderStyle("100px"),
      defaultCellStyle: getCellStyle("center"),
    },
    DocuDate: {
      ...new FieldParams(
        "DocuDate",
        "วันที่เอกสาร",
        true,
        FieldDataType.DATE,
        FormControlType.DATE_PICKER
      ),
      defaultCellStyle: getCellStyle("center"),
      defaultHeaderStyle: GetHeaderStyle("100px"),
      formatter: (cell, row) => <GetThaiDateTimeCheckToday dateValue={cell} />,
    },
    AppointmentDate: {
      ...new FieldParams(
        "AppointmentDate",
        "วันเวลานัด",
        true,
        FieldDataType.DATE,
        FormControlType.DATE_PICKER
      ),
      defaultCellStyle: getCellStyle("center"),
      dateFormat: "dd/MM/yyyy HH:mm",
      defaultHeaderStyle: GetHeaderStyle("100px"),
      formatter: (cell, row) => <GetThaiDateTimeCheckToday dateValue={cell} />,
    },
    Patient: {
      ...new FieldParams(
        "Patient",
        "คนไข้",
        true,
        FieldDataType.NUMERIC,
        FormControlType.SEARCHER
      ),
      tableColumnFieldName: "Patient.PatientFullName",
      searchDisplayName: "PatientFullName",
      searchValueName: "PatientId",
      searchButtonClick: patientClick,
      searchCancelClick: cancleClick,
    },
    Good: {
      ...new FieldParams(
        "Good",
        "ส่วนตรวจ",
        true,
        FieldDataType.NUMERIC,
        FormControlType.SEARCHER
      ),
      tableColumnFieldName: "Good.GoodName",
      searchDisplayName: "GoodName",
      searchValueName: "GoodId",
      searchButtonClick: goodClick,
      searchCancelClick: cancleClick,
    },
    Physician: {
      ...new FieldParams(
        "Physician",
        "แพทย์เจ้าของไข้",
        true,
        FieldDataType.NUMERIC,
        FormControlType.SEARCHER
      ),
      tableColumnFieldName: "Physician.FullName",
      searchDisplayName: "FullName",
      searchValueName: "Staffid",
      searchButtonClick: physicianClick,
      searchCancelClick: cancleClick,
    },
    CustSender: {
      ...new FieldParams(
        "CustSender",
        "หน่วยงานส่งตรวจ",
        true,
        FieldDataType.NUMERIC,
        FormControlType.SEARCHER
      ),
      tableColumnFieldName: "CustSender.CustShortName",
      searchDisplayName: "CustShortName",
      searchValueName: "CustId",
      searchButtonClick: customerClick,
      searchCancelClick: cancleClick,
    },
    BranchRight: {
      ...new FieldParams(
        "BranchRight",
        "สิทธิรักษา",
        true,
        FieldDataType.NUMERIC,
        FormControlType.SEARCHER
      ),
      tableColumnFieldName: "BranchRight.BrchRightName",
      searchDisplayName: "BrchRightName",
      searchValueName: "BrchPatRightId",
      searchButtonClick: rightClick,
      searchCancelClick: cancleClick,
    },
  };
};

export class AppointmentService {
  static async GetList(data, user) {
    return (
      (await PostJson("/api/patient-appment/getlist", { data, user })) ?? null
    );
  }

  static async GetItem(data, user) {
    let result = await PostJson("/api/patient-appment/getitem", {
      data,
      user,
    });
    return result ?? null;
  }

  static async SaveItem(data, user) {
    return (
      (await PostJson("/api/patient-appment/update", { data, user })) ?? null
    );
  }

  static async DeleteItem(data, user) {
    return (
      (await PostJson("/api/patient-appment/delete", {
        data,
        user,
      })) ?? null
    );
  }
}
